// Webpack Polyfill Injector
function main() {
    require("c:/Work/www/mtd/src/app/index.js");
}
var polyfills = function() {
    return [
        /* Object.assign */ ("assign"in Object
) ? 0 : 1,
        /* Promise */ ("Promise"in this
) ? 0 : 1,
        /* fetch */ ("fetch"in this
) ? 0 : 1
    ];
}.call(window);
if (polyfills.indexOf(1) === -1) {
    main();
} else {
    var js = document.createElement('script');
    js.src = "js/polyfills/polyfill.14d400." + polyfills.join('') + '.js';
    js.onload = main;
    js.onerror = function onError(message) {
        console.error('Could not load the polyfills: ' + message);
    };
    document.head.appendChild(js);
}